import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps extends React.SVGProps<SVGSVGElement> {
	checkFillColor?: string;
	className?: string;
	fillColor?: string;
	height?: number;
	width?: number;
}

export const TagCheckIcon: React.FC<IProps> = ({ className, checkFillColor, fillColor, height, width, ...rest }) => {
	return (
		<SvgIcon
			height={height || 24}
			width={width || 24}
			className={`tag-check-icon ${className || ''}`}
			viewBox='0 0 24 24'
			{...rest}
		>
			<g fill='none' fillRule='evenodd'>
				<circle cx='12' cy='12' r='12' fill={fillColor || '#fff'} />
				<polygon
					fill={checkFillColor || '#fff'}
					points='10.901 18 6 12.974 8.143 10.776 10.515 13.209 15.535 6 18 7.805'
				/>
			</g>
		</SvgIcon>
	);
};
